import { render, staticRenderFns } from "./appMain.vue?vue&type=template&id=4dd566f4"
import script from "./appMain.vue?vue&type=script&lang=ts"
export * from "./appMain.vue?vue&type=script&lang=ts"
import style0 from "./appMain.vue?vue&type=style&index=0&id=4dd566f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports